import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const postLead = (payload) => axios.post(`${API}/leads`, payload).then(r => r.data);
export const postAudit = (payload) => axios.post(`${API}/audit`, payload).then(r => r.data);
export const postNewsletter = (email) => axios.post(`${API}/newsletter`, { email }).then(r => r.data);
